import { useEffect,useState} from "react";
import { useSearchParams,useNavigate,NavLink} from "react-router-dom";
import log from "../../../../sitel/commons/services/log";
import authCentral from "../../../../services/authCentral";
import { Alert } from "react-bootstrap";
import { useBaseUrlAuthFlow } from "../../../../services/urlServices";


export default function Step2Login(){
    const [searchParams, ] = useSearchParams();
    const authCode = searchParams.get('ontimecode');
    const [loginStatus,setLoginStatus] = useState('login');
    const navigate=useNavigate();
    const baseAuthUrl = useBaseUrlAuthFlow();
    
    useEffect(() => {
        async function startAuthFlow(){
            log.debug(`Authenticating SSO flow with code ${authCode}`);
            try{
                const success = await authCentral.loadJWTFromServer(`sgu-${authCode}`);
                if(success && authCentral.getCurrentUser()){
                    setLoginStatus('success');
                    navigate(`${baseAuthUrl}/resetpassword/step3/changepassword`);
                } else {
                    setLoginStatus('failed');
                }
            } catch(error){
                setLoginStatus('failed');
            }
        }

        if(authCode){        
          startAuthFlow();
        }
    },[authCode] );


<NavLink className="pull-right" >Forgot my password</NavLink>

    switch(loginStatus){
        case 'login':
            return (
                <span>Logging in ... </span>
            );
        
        case 'success':
            return(
                <span>Redirecting to update password</span>
            );

        default:
            return(<Alert variant="danger" >
                <Alert.Heading>Error logging in</Alert.Heading>
                The link you used has expired or was incorect.
                Please try again <NavLink to={`${baseAuthUrl}/resetpassword/step1/createrequest`}>here</NavLink>.
            </Alert>);
    }
}
